import React, { useState } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import Button from './Button'
import Spinner from './Spinner'
import PRODUCTS_NEW from '../constants/ProductsNew'
import { profileSelector } from '../reducers/profile'
import { getDiscountsSelector } from '../reducers/discounts'
import { activeWebTrialOfferPricesSelector } from '../reducers/profile'
import { getAccount, patchSubscription } from '../actions/api'
import { setDiscounts } from '../actions/utils'
import find from 'lodash/find'
import get from 'lodash/get'

import '../styles/subscription-select.scss'

function SubscriptionManagementSelect({
  patchSubscription,
  id,
  type,
  activeProduct,
  withPay,
  discounts,
  onProductChange = () => {},
  setSubscriptionManagement = () => {}
}) {
  const [loading, setLoading] = useState(false)
  const possibleProducts = PRODUCTS_NEW.filter(item => item.type === type)

  const [selectedProduct, setSelectedProduct] = useState(activeProduct || possibleProducts[0]['product'])

  const handleClick = product => () => {
    setSelectedProduct(product)
    onProductChange(product)
  }

  const handlePayClick = async () => {
    setLoading(true)
    await patchSubscription(id, { product: selectedProduct })
    setLoading(false)
    setSubscriptionManagement(false)
  }

  let selectedPrice = get(find(possibleProducts, { product: selectedProduct }), 'price')
  let discountType = get(find(possibleProducts, { product: selectedProduct }), 'discountType')
  if (discounts[discountType]) {
    const discountPrice = (discounts[discountType] || 0) / 100
    selectedPrice = selectedPrice - discountPrice
  }

  return (
    <>
      <div className="account-caption">Выберите вариант подписки:</div>
      <div className="account-subscription-select">
        {possibleProducts.map((item, index) => (
          <Item {...{ item, selectedProduct, discounts, onClick: handleClick }} key={index} />
        ))}
        {type == 'kids' && (
          <div className="account-subscription-select__badge account-subscription-select__badge--joint">
            <span className="account-subscription-select__badge-mobile">Первые две недели — за 1 рубль</span>
          </div>
        )}
      </div>
      {withPay && (
        <div className="account-subscription__wrap-button">
          <Button onClick={handlePayClick} disabled={loading} isSubscriptionFull>
            {loading ? <Spinner /> : `Сменить тариф`}
          </Button>
        </div>
      )}
    </>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector,
  discounts: getDiscountsSelector,
  activeWebTrialOfferPrices: activeWebTrialOfferPricesSelector
})

export default connect(mapStateToProps, { getAccount, patchSubscription, setDiscounts })(
  React.memo(SubscriptionManagementSelect)
)

const Item = React.memo(
  ({
    item: { product, camelCaseId, price, title, badgeRight, badgeLeft },
    selectedProduct,
    discounts,
    activeWebTrialOfferPrices,
    onClick
  }) => {
    console.log(discounts)
    const discount =
      ((product?.includes('yearly') && discounts.yearly_discount_cents) ||
        (product?.includes('monthly') && discounts.monthly_discount_cents) ||
        (product?.includes('triennial') && discounts?.triennial_discount_cents) ||
        (product?.includes('lifetime') && discounts?.lifetime_discount_cents) ||
        0) / 100

    const trialPriceForProduct = activeWebTrialOfferPrices && activeWebTrialOfferPrices[camelCaseId]
    return (
      <div
        className={classnames('account-subscription-select__item', {
          'account-subscription-select__item--active': product === selectedProduct
        })}
        onClick={onClick(product)}>
        <div className="account-subscription-select__checkbox" />
        {Boolean(discount) && <div className="account-subscription-select__old-price">{price}</div>}
        <div className="account-subscription-select__price">{price - discount} ₽</div>
        <div className="account-subscription-select__period">{title}</div>
        {/* Если есть информация про триал, показываем ее*/}
        {!Boolean(discount) && trialPriceForProduct && (
          <div className="account-subscription-select__badge">
            <span className="account-subscription-select__badge-desktop">
              {trialPriceForProduct === 1
                ? `Первые две недели — за 1 рубль`
                : `Первый месяц — за ${trialPriceForProduct} ₽`}
            </span>
            <span className="account-subscription-select__badge-mobile" />
          </div>
        )}
        {/* Если нет, то статический бейжджик*/}
        {!Boolean(discount) && (badgeRight || badgeLeft) && !trialPriceForProduct && (
          <div className="account-subscription-select__badge">
            <span className="account-subscription-select__badge-desktop">{(badgeRight || badgeLeft)?.desktop}</span>
            <span className="account-subscription-select__badge-mobile">{(badgeRight || badgeLeft)?.mobile}</span>
          </div>
        )}
      </div>
    )
  }
)
